import {EventDto} from "./event-dto";

export class CandidateSlotsDto {
  candidateId: number;
  interviewId: number;
  slots: EventDto[];
}
